/**
 * @generated SignedSource<<fe3486a91c9ab2dfe204e1e36e1443b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InviteAdminToOrganizationInput = {
  applicationId?: string | null | undefined;
  config?: any | null | undefined;
  email: string;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  organizationId: string;
  permissionIds?: ReadonlyArray<string> | null | undefined;
  permissionNames?: ReadonlyArray<string> | null | undefined;
  roleIds?: ReadonlyArray<string> | null | undefined;
  roleNames?: ReadonlyArray<string> | null | undefined;
};
export type useAdminMutationsInviteToOrganizationMutation$variables = {
  input: InviteAdminToOrganizationInput;
};
export type useAdminMutationsInviteToOrganizationMutation$data = {
  readonly inviteAdminToOrganization: {
    readonly email: string;
    readonly firstName: string;
    readonly id: string;
    readonly lastName: string;
  };
};
export type useAdminMutationsInviteToOrganizationMutation = {
  response: useAdminMutationsInviteToOrganizationMutation$data;
  variables: useAdminMutationsInviteToOrganizationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminUser",
    "kind": "LinkedField",
    "name": "inviteAdminToOrganization",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAdminMutationsInviteToOrganizationMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAdminMutationsInviteToOrganizationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "55fb2f44931546595c467fa58267a61e",
    "id": null,
    "metadata": {},
    "name": "useAdminMutationsInviteToOrganizationMutation",
    "operationKind": "mutation",
    "text": "mutation useAdminMutationsInviteToOrganizationMutation(\n  $input: InviteAdminToOrganizationInput!\n) {\n  inviteAdminToOrganization(input: $input) {\n    id\n    email\n    firstName\n    lastName\n  }\n}\n"
  }
};
})();

(node as any).hash = "d741ebe3c4b2f803edabb22f0d79e4e5";

export default node;
